import React, { useRef, useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import GridContainer from '../components/GridContainer';
import gamesService from '../../gameData/services/gamesService';

function GridsInfinitScroll({
  eventRef,
  gamesData,
  featureUniverseId,
  pageType,
  apiParams,
  gameSortPosition,
  sortPageContext,
  ...props
}) {
  const infiniteScrollRef = useRef();
  const [gridGameData, setGridGameData] = useState(gamesData);
  const [dataFetchParams, setDataFetchParams] = useState(apiParams);
  const [isDataFetching, setDataFetching] = useState(false);

  const validateIfNeedToFetchMoreData = useCallback(() => {
    const infiniteScrollOffset =
      infiniteScrollRef.current?.offsetTop + infiniteScrollRef.current?.clientHeight;
    const windowOffset = window.pageYOffset + window.innerHeight;
    if (windowOffset > infiniteScrollOffset) {
      console.log(
        `validateIfNeedToFetchMoreData---${infiniteScrollOffset}---windowOffset---${windowOffset}`
      );
      if (!dataFetchParams.hasMoreRows) {
        window.removeEventListener('scroll', validateIfNeedToFetchMoreData);
      } else {
        setDataFetching(true);
      }
    }
  }, [dataFetchParams.hasMoreRows]);

  const loadMore = useCallback(() => {
    if (dataFetchParams.hasMoreRows) {
      gamesService
        .getGamesList(dataFetchParams)
        .then(
          result => {
            if (result?.games) {
              setGridGameData(currentGamesData => {
                const updateGamesData = currentGamesData.concat(result.games);
                return updateGamesData;
              });
            }
            const updatedApiParams = gamesService.buildUpdatedApiParams(result, dataFetchParams);

            setDataFetchParams(currentDateFetchParams =>
              Object.assign(currentDateFetchParams, updatedApiParams)
            );
          },
          error => {
            console.error(`getGameList${error}`);
            setDataFetchParams(currentDateFetchParams =>
              Object.assign(currentDateFetchParams, { hasMoreRows: false })
            );
          }
        )
        .finally(() => {
          setDataFetching(false);

          if (dataFetchParams.hasMoreRows) {
            validateIfNeedToFetchMoreData();
          }
        });
    }
  }, [dataFetchParams, validateIfNeedToFetchMoreData]);

  useEffect(() => {
    if (!isDataFetching) return;
    loadMore();
  }, [isDataFetching, loadMore]);

  useEffect(() => {
    console.log(`------------------- attachScrollEvent---------------------`);
    if (infiniteScrollRef.current) {
      validateIfNeedToFetchMoreData(); // should handle once when page first loaded
      window.addEventListener('scroll', validateIfNeedToFetchMoreData);
    }

    return () => {
      window.removeEventListener('scroll', validateIfNeedToFetchMoreData);
    };
  }, [validateIfNeedToFetchMoreData]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='infinite-scroll-container' ref={infiniteScrollRef}>
      <GridContainer
        eventRef={eventRef}
        gamesData={gridGameData}
        featureUniverseId={featureUniverseId}
        pageType={pageType}
        isDataFetching={isDataFetching}
        sortPosition={gameSortPosition}
        pageContext={sortPageContext}
        {...props}
      />
    </div>
  );
}

GridsInfinitScroll.defaultProps = {
  eventRef: undefined,
  featureUniverseId: null,
  gameSortPosition: -1,
  sortPageContext: { pageId: null }
};

GridsInfinitScroll.propTypes = {
  eventRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) })
  ]),
  gamesData: PropTypes.arrayOf(PropTypes.shape({ universeId: PropTypes.number })).isRequired,
  pageType: PropTypes.string.isRequired,
  featureUniverseId: PropTypes.number,
  apiParams: PropTypes.shape({}).isRequired,
  gameSortPosition: PropTypes.number,
  sortPageContext: PropTypes.shape({ pageId: PropTypes.string }),
  translate: PropTypes.func.isRequired
};
export default GridsInfinitScroll;
